import PositionNextBusesService from 'js/services/api/position/next-buses.js'

export default {
  methods: {
    /*
     * Función del botón de la vista para calcular el tiempo de paso previsto al punto más cercano
     * al usuario respeco de la ruta
     */
    nearUser() {
      this.closePopups()

      this.$set(this, 'nextBuses', undefined)
      this.$set(this, 'routePoint', undefined)
      this.$set(this, 'routePointMarker', undefined)

      this.shouldCenterMap = true

      const params = {
        lat: this.userPosition.lat,
        lng: this.userPosition.lng,
        route_id: this.selectedRouteId
      }

      PositionNextBusesService.get({params, skipLoading: true}).then(response => {
        if (_.isEmpty(response.body.buses) || response.body.route_point.distance > 1000) {
          this.userPositionNearError()
        } else {
          // Comprobar el tiempo de cada bus y el tiempo actual estimado
          _.each(response.body.buses, bus => {
            const delay = moment().diff(bus.datetime) / 1000.0
            const realTime = bus.time - delay
            bus.real_time = (Math.floor(realTime >= 0 ? (realTime / 60) : undefined))
          })

          const nextBus = _.minBy(response.body.buses, 'real_time')

          if (nextBus) {
            this.$set(this, 'nextBuses', [nextBus])
            this.$set(this, 'routePoint', response.body.route_point)
          } else {
            this.userPositionNearError()
          }
        }
      })
    },

    userPositionNearError() {
      this.$notifications.send({
        id: 'too-far-from-route',
        text: this.$t('errors.noBuses'),
        type: 'error',
        close: true
      })
      this.$set(this, 'nextBuses', undefined)
      this.$set(this, 'routePoint', undefined)
      this.$set(this, 'routePointMarker', undefined)
    }
  }
}
